
import Vue from "vue";
import store from "@/store";
import router from "@/router";
import DefaultLayout from "@/layout/DefaultLayout.vue";
import AppLoading from "@/components/UI/AppLoading.vue";
import token from "@/static/JWT";

export default Vue.extend({
  name: "ProfilePage",
  components: {
    DefaultLayout,
    AppLoading,
  },
  computed: {
    mobileSize() {
      return this.$vuetify.breakpoint.mobile;
    },
  },
  watch: {
    mobileSize() {
      // push to child route if it's on larger screen
      if (!this.$vuetify.breakpoint.mobile && this.$route.name === "profile")
        router.push("/profile/personal-info");
    },
  },
  created() {
    // get user profile
    if (store.state.panel.user || token) {
      // start page loading
      store.state.app.pageLoading = true;

      setTimeout(function () {
        store.dispatch("panel/getProfile");
      }, 500);
    } else {
      router.push({ name: "login" });
    }

    // move to child route if it's on larger screen on first mount
    if (!this.$vuetify.breakpoint.mobile && this.$route.name === "profile")
      router.push("/profile/personal-info");
  },
});
